import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: 'auto',
    width: '60%',
    maxWidth: 1700,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    backgroundColor: theme.palette.background.default,

    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 12,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 12
  },
  circularProgressContianer: {
    marginTop: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  }
}))
export default useStyles
